import { filterPartiesByPartyTypeCode } from "./filterPartiesByPartyTypeCode";

export const getAllOwnersFromParties = (parties) => {
  return filterPartiesByPartyTypeCode(parties, ["OW", "JO"]);
};
